export default {
  postCheck: (state) => {
    return state.postCheck;
  },

  loginCheck: (state) => {
    return state.loginCheck;
  },

  forgotCheck: (state) => {
    return state.forgotCheck;
  },
  forgotBtn: (state) => {
    return state.forgotBtn;
  },

  currentPerson: (state) => {
    return state.currentPerson;
  },

  loadingBtn: (state) => {
    return state.loadingBtn;
  },

  errorMessage: (state) => {
    return state.errorMessage;
  },
  modalVisibility: (state) => {
    return state.modalVisibility;
  },
};
